import React from 'react';

import AssociationAdminFormView from 'screens/associations/AssociationAdminForms/view';

const AssociationAdminFormViewScreen = () => <AssociationAdminFormView />;

export default AssociationAdminFormViewScreen;
